import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const GoogleCalendarModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleOpenCalendarModal = () => {
      setIsOpen(true);
    };

    window.addEventListener("openCalendarModal", handleOpenCalendarModal);

    return () => {
      window.removeEventListener("openCalendarModal", handleOpenCalendarModal);
    };
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-5xl max-h-[90vh] p-6 bg-white rounded-lg shadow-lg">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-primary">
            PMX Schedule
          </DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <iframe
            title="PMX Health Calendar"
            src="https://calendar.google.com/calendar/embed?height=600&wkst=2&ctz=Asia%2FKolkata&mode=AGENDA&showPrint=0&showTz=0&title=PMX%20Schedule&src=ZHJzYW1hdGhhQHBteGhlYWx0aC5jb20&color=%23039BE5"
            className="border-0"
            width="100%"
            height="600"
            frameBorder="0"
            scrolling="no"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};